import { IEnderecoUser } from "shared/interfaces/IEnderecoUser";
import { api } from "../api";

/* ===================================
   CRIAR ENDEREÇO
=================================== */

export async function criarEndereco(
  data: any,
  nomeRecebedor?: string,
): Promise<string> {
  try {
    const payload = {
      label: data.nome,
      recipientName: data.nome,
      zipCode: data.cep,
      street: data.rua,
      number: data.numero,
      complement: data.complemento || "",
      neighborhood: data.bairro,
      city: data.cidade,
      state: data.estado,
      country: "BR",
      isDefault: false,
    };

    const response = await api.post("/identity/users/me/addresses", payload);
    return response.data.id;
  } catch (error: any) {
    console.error("❌ Erro ao criar endereço:", error);

    throw error;
  }
}

/* ===================================
   BUSCAR ENDEREÇOS
=================================== */

export async function buscarEnderecos(): Promise<IEnderecoUser[]> {
  const response = await api.get(`/identity/users/me/addresses`);

  return response.data.map((endereco: any) => ({
    id: endereco.id,
    nome: endereco.label,
    rua: endereco.street,
    numero: endereco.number,
    cidade: endereco.city,
    cep: endereco.zipCode,
    bairro: endereco.neighborhood,
    estado: endereco.state,
    complemento: endereco.complement ?? "",
    enderecoPrincipal: endereco.isDefault ?? false,
    lat: endereco.lat,
    lng: endereco.lng,
  }));
}

/* ===================================
   BUSCAR ENDEREÇO
=================================== */

export async function buscarEnderecoPorId(
  id: string,
): Promise<IEnderecoUser | null> {
  try {
    const { data } = await api.get(`/identity/users/me/addresses/${id}`);
    const endereco = {
      id: data.id,
      nome: data.label,
      rua: data.street,
      numero: data.number ?? "",
      cidade: data.city,
      cep: data.zipCode,
      bairro: data.neighborhood ?? "",
      estado: data.state ?? "",
      complemento: data.complement ?? "",
      enderecoPrincipal: data.isDefault ?? false,
      lat: data.lat,
      lng: data.lng,
      
      
    };

    return endereco ?? null;
  } catch (error) {
    console.error("❌ Erro ao buscar endereço:", error);
    return null;
  }
}

/* ===================================
   ATUALIZAR ENDEREÇO
=================================== */

export async function atualizarEndereco(
  addressId: string,
  data: any,
): Promise<void> {
  try {
    const payload = {
      label: data.nome,
      recipientName: data.nome,
      zipCode: data.cep,
      street: data.rua,
      number: data.numero,
      complement: data.complemento || "",
      neighborhood: data.bairro,
      city: data.cidade,
      state: data.estado,
      country: "BR",
    };


    await api.patch(`/identity/users/me/addresses/${addressId}`, payload);
  } catch (error: any) {
    console.error("❌ Erro ao atualizar endereço:", error);
    console.error("STATUS:", error?.response?.status);
    console.error("BODY:", error?.response?.data);
    throw error;
  }
}
/* ===================================
   EXCLUIR ENDEREÇO
=================================== */

export async function excluirEndereco(id: string): Promise<void> {
  try {
    await api.delete(`/identity/users/me/addresses/${id}`);
  } catch (error) {
    console.error("❌ Erro ao excluir endereço:", error);

    throw error;
  }
}

/* ===================================
   DEFINIR PRINCIPAL
=================================== */

export async function definirComoPrincipal(id: string): Promise<void> {
  try {
    const body = {
      isDefault: true,
    };


    await api.patch(
      `/identity/users/me/addresses/${id}`,
      body,
    );

  } catch (error: any) {
    console.error("URL:", error.config?.url);
    console.error("STATUS:", error.response?.status);
    console.error("BODY:", error.response?.data);

    throw error;
  }
}
